const getCharSortPriority = (char: string): number => {
    if (!char) return 4;
    if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(char)) return 1;
    if (/[a-zA-Z]/.test(char)) return 2;
    if (/[0-9]/.test(char)) return 3;
    return 4;
};

/**
 * @desc 한글(가나다) → 영문(ABC) → 숫자(123) 순으로 정렬한다.
 */
export const sortByKoEnNumOrder = (nameA: string, nameB: string, locale: string = 'ko'): number => {
    const trimmedA = nameA.trim();
    const trimmedB = nameB.trim();

    const priorityA = getCharSortPriority(trimmedA.charAt(0));
    const priorityB = getCharSortPriority(trimmedB.charAt(0));

    if (priorityA !== priorityB) {
        return priorityA - priorityB;
    }

    return trimmedA.localeCompare(trimmedB, locale, {
        numeric: true,
        sensitivity: 'base',
        ignorePunctuation: true,
    });
};
